(() => {
  const lpmText = window.lpmText || (source => source);
  function finishKey(value) {
    const text = (value || '').trim().toLowerCase();
    if (/rosa|rose|rosé/.test(text)) return 'rose-gold';
    if (/(oro|ouro|gold|dorad|dourad)/.test(text) && /(plata|prata|silver|platead|pratead)/.test(text)) return 'two-tone';
    if (/oro|ouro|gold|dorad|dourad/.test(text)) return 'gold';
    if (/plata|prata|silver|platead|pratead/.test(text)) return 'silver';
    return text;
  }
  function init(scope = document) {
    scope.querySelectorAll('.clx-hero').forEach(hero => {
      if (hero.dataset.pdpReady) return;
      hero.dataset.pdpReady = 'true';
      const root = hero.closest('.clx, .clv, .tax, .brx');
      const buy = hero.querySelector('.clx-buy');
      if (!root || !buy) return;
      const primary = buy.querySelector('.pw-open, .clx-atc, [data-pw-open]');
      const sticky = root.querySelector('.clx-sticky');
      const shortcuts = [...root.querySelectorAll('[data-pdp-choose]')];
      const related = [...root.querySelectorAll('[data-pdp-related]')].flatMap(card => {
        try { return [{ card, variants: JSON.parse(card.dataset.pdpRelated) }]; } catch { return []; }
      });
      let choseOptions = false;
      function sync() {
        const choice = [...buy.querySelectorAll('fieldset legend span')].map(el => el.textContent.trim()).filter(Boolean).join(' · ');
        const title = sticky?.querySelector('.clx-sticky-t');
        if (title && choice) title.textContent = choice;
        shortcuts.forEach(button => {
          button.disabled = !primary || primary.disabled;
          const label = button.disabled ? (primary?.dataset.pdpAvailable === 'true' ? lpmText('Añadiendo…') : lpmText('Agotado')) : choseOptions ? lpmText('Añadir a la cesta') : lpmText('Elegir opciones');
          const first = button.firstChild;
          if (first?.nodeType === Node.TEXT_NODE) first.nodeValue = label + (button.querySelector('span') ? ' · ' : '');
          button.setAttribute('aria-label', `${label}${choice ? ': ' + choice : ''}`);
        });
        const variant = root.querySelector('form [name="id"]')?.value || root.dataset.clxVariant || buy.querySelector('input[type=radio]:checked')?.value || primary?.dataset.variantId;
        if (variant) root.querySelectorAll('[data-pdp-reviews]').forEach(link => {
          const url = new URL(link.href);url.searchParams.set('variant', variant);link.href = url.href;
        });
        const finish = finishKey(buy.querySelector('input[data-pdp-color]:checked')?.dataset.pdpColor || buy.querySelector('fieldset legend span')?.textContent || '');
        related.forEach(({ card, variants }) => {
          const selected = variants.find(item => finishKey(item.color) === finish) || variants[0];
          if (!selected || card.dataset.pdpRelatedVariant === String(selected.id)) return;
          card.dataset.pdpRelatedVariant = String(selected.id);
          const url = new URL(card.href);url.searchParams.set('variant', selected.id);card.href = url.href;
          const image = card.querySelector('img');
          if (image && selected.image) { image.src = selected.image; image.removeAttribute('srcset'); }
          const color = card.querySelector('.clx-related-finish');
          if (color) color.textContent = selected.color;
          card.querySelector('strong').textContent = selected.price;
          const compare = card.querySelector('s');
          compare.hidden = !selected.compare; compare.textContent = selected.compare || '';
        });
      }
      buy.addEventListener('click', event => {
        if (event.target.closest('fieldset button, fieldset input')) { choseOptions = true; requestAnimationFrame(sync); }
      });
      buy.addEventListener('change', event => { if (event.target.closest('fieldset')) { choseOptions = true; requestAnimationFrame(sync); } });
      shortcuts.forEach(button => button.addEventListener('click', () => {
        if (!primary || primary.disabled) return;
        if (choseOptions) { primary.click(); return; }
        const target = buy.querySelector('fieldset button:not(:disabled), fieldset input:not(:disabled)') || primary;
        target.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        target.focus({ preventScroll: true });
      }));
      if (sticky && primary && 'IntersectionObserver' in window) {
        new IntersectionObserver(entries => {
          const hidden = entries[0].isIntersecting;
          sticky.style.transform = hidden ? 'translateY(100%)' : 'translateY(0)';
          sticky.inert = hidden;
        }, { rootMargin: '-80px 0px 0px 0px' }).observe(primary);
      }
      const observer = new MutationObserver(() => requestAnimationFrame(sync));
      observer.observe(buy, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-pressed', 'disabled'] });
      root.querySelectorAll('[class*=atc-err]').forEach(el => el.setAttribute('role', 'alert'));
      sync();
    });
    scope.querySelectorAll('.clx-thumbs > img').forEach(img => {
      if (img.dataset.pdpKeyboard) return;
      img.dataset.pdpKeyboard = 'true';img.tabIndex = 0;img.setAttribute('role', 'button');
      img.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault();img.click(); } });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
